import axios from 'axios';

// Uses plain axios (no auth headers) for public endpoints
import { API_BASE_URL as BASE_URL } from './config';

const publicApi = axios.create({ baseURL: BASE_URL });

export interface PublicMenuItem {
  id: string;
  name: string;
  price: number;
  vegType: 'VEG' | 'NON_VEG' | 'VEGAN';
  categoryId?: string;
  categoryName?: string;
  gstPercent?: number;
  available: boolean;
}

export interface PublicOrderItem {
  itemId: string;
  itemName: string;
  quantity: number;
  unitPrice: number;
  specialNotes?: string;
}

export interface OrderRequest {
  id?: string;
  restaurantId: string;
  tableId: string;
  customerName: string;
  customerMobile: string;
  items: PublicOrderItem[];
  status?: string;
  createdAt?: string;
}

export interface TableOrderInfo {
  table: {
    id: string;
    name: string;
    capacity: number;
    status: string;
  };
  currentOrders: any[];
  hasOpenOrder: boolean;
}

export const customerOrderService = {
  getMenu: async (restaurantId: string): Promise<PublicMenuItem[]> => {
    const res = await publicApi.get(`/public/restaurant/${restaurantId}/menu`);
    return res.data;
  },

  getTableInfo: async (restaurantId: string, tableId: string): Promise<TableOrderInfo> => {
    const res = await publicApi.get(`/public/restaurant/${restaurantId}/table/${tableId}`);
    return res.data;
  },

  placeOrderRequest: async (restaurantId: string, tableId: string, request: OrderRequest): Promise<OrderRequest> => {
    const res = await publicApi.post(
      `/public/restaurant/${restaurantId}/table/${tableId}/order-request`,
      request
    );
    return res.data;
  },

  callWaiter: async (restaurantId: string, tableId: string): Promise<void> => {
    await publicApi.post(`/public/restaurant/${restaurantId}/table/${tableId}/waiter-call`);
  },
};
